import * as RadixToast from '@radix-ui/react-toast';
import type { ReactNode } from 'react';

export function ToastProvider({ children }: { children: ReactNode }) {
  return (
    <RadixToast.Provider swipeDirection="right" duration={3000}>
      {children}
      <RadixToast.Viewport className="fixed bottom-4 right-4 flex flex-col gap-2 w-96 max-w-full z-50 outline-none" />
    </RadixToast.Provider>
  );
}

interface ToastProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  message: string;
}

export function Toast({ open, onOpenChange, message }: ToastProps) {
  return (
    <RadixToast.Root
      open={open}
      onOpenChange={onOpenChange}
      className="bg-surface border border-border rounded-lg shadow-card p-3 text-text"
    >
      <RadixToast.Description>{message}</RadixToast.Description>
    </RadixToast.Root>
  );
}
